export var PermissionKey;
(function (PermissionKey) {
  PermissionKey["READ_USER"] = "READ_USER";
  PermissionKey["UPDATE_USER"] = "UPDATE_USER";
  PermissionKey["READ_USER_LIST"] = "READ_USER_LIST";
  PermissionKey["REQUEST_VERIFICATION"] = "REQUEST_VERIFICATION";
  PermissionKey["READ_ORGANIZATION_LIST"] = "READ_ORGANIZATION_LIST";
  PermissionKey["READ_ORGANIZATION"] = "READ_ORGANIZATION";
  PermissionKey["CREATE_ORGANIZATION"] = "CREATE_ORGANIZATION";
  PermissionKey["UPDATE_ORGANIZATION"] = "UPDATE_ORGANIZATION";
  PermissionKey["DELETE_ORGANIZATION"] = "DELETE_ORGANIZATION";
  PermissionKey["CREATE_USER_INVITATION"] = "CREATE_USER_INVITATION";
  PermissionKey["UPDATE_MEMBERSHIP"] = "UPDATE_MEMBERSHIP";
  PermissionKey["DELETE_MEMBERSHIP"] = "DELETE_MEMBERSHIP";
  PermissionKey["READ_OWN_PROFILE"] = "READ_OWN_PROFILE";
  PermissionKey["UPDATE_OWN_PROFILE"] = "UPDATE_OWN_PROFILE";
  PermissionKey["DELETE_OWN_PROFILE"] = "DELETE_OWN_PROFILE";
  PermissionKey["NOTIFICATION_SETTINGS_ACCESS"] = "NOTIFICATION_SETTINGS_ACCESS";
  // Permissions for Admin Tasks
  PermissionKey["DEPLOY_TRANSLATIONS"] = "DEPLOY_TRANSLATIONS";
  PermissionKey["DELETE_USER"] = "DELETE_USER";
  PermissionKey["CONTACT_USER_WITH_NOTIFICATION"] = "CONTACT_USER_WITH_NOTIFICATION";
  // Feature Flags
  PermissionKey["MANAGE_FEATURE_FLAG_ASSIGNMENTS"] = "MANAGE_FEATURE_FLAG_ASSIGNMENTS";
})(PermissionKey || (PermissionKey = {}));
